// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '@hotwired/turbo-rails'
import SortableController from './controllers/sortable_controller'
import { Application } from '@hotwired/stimulus'
const application = Application.start()
application.register('sortable', SortableController)

// notice を一定時間たったら消す
import './fade_out.js'

// require('@rails/ujs').start()
// require('turbolinks').start()
// require('@rails/activestorage').start()
// require('./channels')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// import 'stylesheets/application'
// import '@fortawesome/fontawesome-free/css/all'
